export default __webpack_public_path__ + "static/media/PowellCatLocation-2.d4808c23.jpg";